<div class="modal-header">
    <h5 class="fw-bold pt-4 ps-4">
        <span class="text-uppercase ms-3 badge bg-light"></span>
    </h5>
    <button type="button" class="btn-close mt-4 me-4" mat-dialog-close></button>
</div>

<mat-dialog-content class="mat-typography">
    <div class="modal-body">
        <div class="overflow-auto w-100">
            <div class="row">
                <div class="col-lg-4 col-md-4">
                    <h5 class="fw-bold">
                        <span class="text-uppercase badge bg-light"><mat-icon class="ms-3 align-middle txt-primary">shelves</mat-icon><strong class="ms-1 me-3 txt-dark h6 mt-1 pt-2 pb-2 ps-2 pe-2">{{rack.nombre}}</strong></span>
                    </h5>
                </div>
            </div>
            <div>
                <label *ngIf="saveEst" class="mt-3">Seleccione con que estación comparte inventario: </label>
                <label *ngIf="!saveEst" class="mt-3">Esta estación comparte inventario con: </label>

                <div class="mt-3">
                    <mat-form-field appearance="fill">
                        <mat-label>Estación</mat-label>
                        <mat-select [(ngModel)]="rack_sel" [disabled]="!saveEst">
                            <mat-option [value]="'Ninguna'">Ninguna</mat-option>
                            <mat-option *ngFor="let est of select_estaciones" [value]="est.id">
                                {{est.nombre.replace('Estacion', 'Estación')}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions *ngIf="saveEst" style="justify-content: flex-end;" class="me-4">
    <button mat-flat-button class="bg-success text-white" type="button" (click)="guardarEstacionCompartida()">Guardar <mat-icon>save</mat-icon></button>
</mat-dialog-actions>
